import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, first } from 'rxjs/operators';
import {
  QuotationResponse, QuotationDataSourceResponse, QuotationEntityType, QuotationContactListResponse, OrderListResponse,
  FilterOrderRequest, QuotationModel, SaveQuotationResponse, AddressFactoryResponse, SetStatusRequest, SetStatusQuotationResponse, QuotationManDayResponse, QuoationMandayrequest, QuotProduct, QuotCheckpointRequest
} from '../../_Models/quotation/quotation.model';
import { QuotationSummaryResponse, QuotationDataSummaryResponse, Quotationsummarymodel } from 'src/app/_Models/quotation/quotationsummary.model';
import { QuotationCustomerPriceCard } from 'src/app/_Models/customer/customer-price-card.model';
import { InvoiceModel } from '../../_Models/quotation/quotationsummary.model';
import { QuotationChangeStatusRequest, QuotationHistoryResponse, QuotationNewDataSummaryResponse, QuotationNewsummarymodel, QuotationUploadedSummaryResponse } from 'src/app/_Models/quotationNew/quotationNewsummary.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class QuotationSummaryService {

  url: string
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl;

    if (this.url.charAt(this.url.length - 1) == '/')
      this.url = this.url.substring(0, this.url.length - 1);
  }


  getQuotationDataSummary(model: QuotationNewsummarymodel) {
    return this.http
      .post<any>(`${this.url}/api/quotationSummary/quotation-list`, model)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getQuotationUploadedList(model: QuotationNewsummarymodel): Observable<QuotationUploadedSummaryResponse> {
    return this.http.post<QuotationUploadedSummaryResponse>(
      `${this.url}/api/quotationSummary/quotation-uploaded-list`,
      model
    );
  }

  getQuotationHistory(id: number): Observable<QuotationHistoryResponse[]> {
    return this.http.get<QuotationHistoryResponse[]>(
      `${this.url}/api/quotationSummary/quotation-history/${id}`
    );
  }

  // Get quotation details by ID (for reupload - fetches existing files from database)
  getQuotationDetails(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.url}/api/quotationSummary/quotation-details/${id}`
    );
  }

  // Submit quotation with files (legacy method - uploads files directly)
  submitQuotation(formData: FormData) {
    return this.http
      .post<any>(`${this.url}/api/quotationSummary/submit-quotation`, formData)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // Submit quotation with cloud file URLs (new method - files already uploaded to cloud)
  submitQuotationWithUrls(data: any) {
    return this.http
      .post<any>(`${this.url}/api/quotationSummary/submit-quotation`, data)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // Re-upload quotation with cloud file URLs
  reuploadQuotationWithUrls(data: any) {
    return this.http
      .post<any>(`${this.url}/api/quotationSummary/reupload-quotation`, data)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateQuotationStatus(data: QuotationChangeStatusRequest): Observable<number> {
    return this.http
      .post<number>(`${this.url}/api/quotationSummary/quotation-change-status`, data)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // Get supporting documents for a quotation
  getSupportingDocuments(quotationId: number): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.url}/api/quotationSummary/supporting-documents/${quotationId}`)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // Save supporting documents (upload new, delete marked)
  saveSupportingDocuments(data: any): Observable<any> {
    return this.http
      .post<any>(`${this.url}/api/quotationSummary/save-supporting-documents`, data)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // Export quotation summary
exportQuotationSummary(request: any): Observable<Blob> {
  return this.http.post<Blob>(
    `${this.url}/api/quotationSummary/ExportQuotationSearchSummary`,
    request,
    { responseType: 'blob' as 'json' }  // Important fix
  );
}

// Export uploaded quotation summary
exportQuotationUploadedSummary(request: any): Observable<Blob> {
  return this.http.post<Blob>(
    `${this.url}/api/quotationSummary/ExportQuotationUploadedSummary`,
    request,
    { responseType: 'blob' as 'json' }  // Important fix
  );
}
}
